import { useEffect } from "react";
import { useApp } from "@/context/AppContext";

const setMeta = (attribute, key, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) { element = document.createElement("meta"); element.setAttribute(attribute, key); document.head.appendChild(element); }
  element.setAttribute("content", content);
};

export const Seo = ({ title, description, image, structuredData }) => {
  const { language } = useApp();
  useEffect(() => {
    const fullTitle = title.includes("kamerbooking") ? title : `${title} | kamerbooking by YAYA`;
    const canonicalUrl = `${window.location.origin}${window.location.pathname}`;
    document.title = fullTitle;
    document.documentElement.lang = language;
    setMeta("name", "description", description);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", canonicalUrl);
    setMeta("property", "og:locale", language === "fr" ? "fr_CM" : language === "es" ? "es_ES" : "en_CM");
    if (image) setMeta("property", "og:image", image);
    setMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) { canonical = document.createElement("link"); canonical.rel = "canonical"; document.head.appendChild(canonical); }
    canonical.href = canonicalUrl;
    const oldJson = document.getElementById("kamerbooking-jsonld"); if (oldJson) oldJson.remove();
    if (structuredData) { const script = document.createElement("script"); script.id = "kamerbooking-jsonld"; script.type = "application/ld+json"; script.textContent = JSON.stringify(structuredData); document.head.appendChild(script); }
  }, [title, description, image, structuredData, language]);
  return null;
};